import Seo from "@/components/Seo";
import { PageHero, BadgeAC, DevisCta } from "@/components/Shared";
import { Quote } from "lucide-react";

export default function References() {
  return (
    <div data-testid="page-references">
      <Seo
        title="Références & témoignages — Form Action Pro"
        description="Études de cas et témoignages clients de Form Action Pro, organisme de formation : IA, no-code, hygiène alimentaire et Plan de Maîtrise Sanitaire."
        path="/references"
      />
      <PageHero
        kicker="Références"
        title="Études de cas & témoignages"
        subtitle="L’organisme est jeune et cette page grandira avec lui : les premières études de cas et les premiers témoignages seront publiés ici, dès qu’ils seront disponibles."
      />

      <section className="bg-sable py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="font-serif text-3xl text-marine mb-10">Études de cas</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[1, 2, 3].map((n) => (
              <div
                key={n}
                data-testid={`etude-cas-${n}`}
                className="bg-white border border-dashed border-bordure rounded-lg p-8 flex flex-col gap-4 min-h-[220px]"
              >
                <BadgeAC />
                <h3 className="font-serif text-xl text-marine/50">Étude de cas n°{n}</h3>
                <p className="font-sans text-sm text-gris-texte leading-relaxed flex-1">
                  Contexte, intervention et résultats seront publiés ici après accord du client.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="font-serif text-3xl text-marine mb-10">Témoignages</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[1, 2].map((n) => (
              <div
                key={n}
                data-testid={`temoignage-${n}`}
                className="bg-sable border border-dashed border-bordure rounded-lg p-8"
              >
                <Quote className="text-vert/40 mb-4" size={28} />
                <p className="font-serif italic text-lg text-gris-texte mb-6">
                  « Témoignage client à venir. »
                </p>
                <BadgeAC />
              </div>
            ))}
          </div>
          <p className="font-sans text-sm text-gris-texte italic mt-8">
            Vous avez suivi une formation Form Action Pro ? Votre témoignage est le bienvenu —
            contactez-nous.
          </p>
        </div>
      </section>

      <DevisCta />
    </div>
  );
}
